var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05059 9.70135C2.01799 9.77996 2 9.86615 2 9.95654C2 10.134 2.06929 10.2952 2.18229 10.4146C2.18705 10.4196 2.19189 10.4246 2.1968 10.4295L4.86193 13.0946C5.12228 13.3549 5.54439 13.3549 5.80474 13.0946C6.06509 12.8343 6.06509 12.4121 5.80474 12.1518L4.27614 10.6232H10.6667C12.5076 10.6232 14 9.13081 14 7.28988V4.62321C14 4.25502 13.7015 3.95654 13.3333 3.95654C12.9651 3.95654 12.6667 4.25502 12.6667 4.62321V7.28988C12.6667 8.39448 11.7713 9.28988 10.6667 9.28988H4.27614L5.80474 7.76128C6.06509 7.50094 6.06509 7.07882 5.80474 6.81847C5.54439 6.55812 5.12228 6.55812 4.86193 6.81847L2.1968 9.4836C2.19219 9.48818 2.18765 9.49282 2.18318 9.49753C2.12524 9.5585 2.08104 9.62775 2.05059 9.70135Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.7d84ffd003a717747e842991a31edea5.svg";
export { ForwardRef as ReactComponent };